//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


const STAR_ICONS = {
  gold: require('../../assets/gold.svg'),
  silver: require('../../assets/silver.svg'),
  bronze: require('../../assets/bronze.svg')
};

export default {
  name: 'RoundMvp',
  props: {
    mvpList: {
      type: Array,
      default: () => []
    }
  },
  mounted() {
  },
  computed: {
    mvpCount() {
      return this.mvpList ? this.mvpList.length : 0;
    }
  },
  methods: {
    mvpStarSrc(index) {
      if (this.mvpCount <= 2) {
        return STAR_ICONS.gold;
      }

      const rankMap = ['silver', 'gold', 'bronze'];
      const key = rankMap[index] || 'gold';

      return STAR_ICONS[key];
    },

    getItemName(item) {
      if (!item) return '';
      if (item.extra && item.extra.n && item.extra.n[1]) {
        return item.extra.n[1];
      }
      return item.name || '';
    },

    getAnimationStyle(index, count) {
      if (count === 1) {
        return { animationDelay: '0s', animationDuration: '0.9s' };
      }

      if (count === 2) {
        const delayMap = { 0: '0s', 1: '0.8s' };
        return { animationDelay: delayMap[index] || '0s' };
      }

      if (count >= 3) {
        const delayMap = { 2: '0s', 0: '0.5s', 1: '1s' };
        return { animationDelay: delayMap[index] || '0s' };
      }

      return {};
    },
    getUserAvatar(user) {
      if (!user) return require('@/assets/images/user/ava_none.jpg');
      return user.avatar || require('@/assets/images/user/ava_none.jpg');
    },

    formatMultiplier(val) {
      return `x${val}`;
    },

    getItemImage(item) {
      if (!item) return '';
      return item.itemPic || '';
    }
  }
};
